import React from 'react';
import { motion } from 'framer-motion';
const CART_URL = 'https://www.tusoluciondigital.shop/cart/43130152714306:1';
export function HeroSection() {
  return <section className="bg-white py-12 md:py-20 px-4" data-id="element-114">
      <div className="max-w-5xl mx-auto text-center" data-id="element-115">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl lg:text-6xl font-black text-gray-900 mb-6 leading-tight" data-id="element-116">
          💖 "Hice esto para dejar de pensar en él en 7 días"
        </motion.h1>

        <motion.a href={CART_URL} initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="inline-block mb-8" data-id="element-117">
          <img src="https://cdn.magicpatterns.com/uploads/qfaeMNrho8oCceAkaRKSXQ/imagen_1.png" alt="Ebook Principal" className="w-full max-w-[1080px] mx-auto rounded-lg shadow-2xl hover:scale-105 transition-transform duration-300 cursor-pointer" data-id="element-118" />
        </motion.a>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-xl md:text-2xl text-gray-700 mb-8 font-semibold" data-id="element-119">
          El sistema que ya ayudó a +12.847 chicas a soltar, sanar y recuperar
          su amor propio.
        </motion.p>

        <motion.a href={CART_URL} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="inline-block bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 uppercase" data-id="element-120">
          👉 SÍ, QUIERO EMPEZAR HOY Y SOLTARLO DE UNA VEZ
        </motion.a>

        <p className="text-sm text-gray-600 mt-4" data-id="element-121">
          ✅ Garantía de satisfacción de 7 días
        </p>
      </div>
    </section>;
}